import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectPrice, selectProjectTitle } from '../../selectors';
import { Heading } from '../../components/Heading';

export const HeadingContainer = () => {
  const projectTitle = useSelector(selectProjectTitle);
  const { startPrice } = useSelector(selectPrice);

  return <Heading title={projectTitle} price={startPrice} />;
};
